const styleSheet = () => ({
  flexContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: '6px',
  },
  flexItem: {
    display: 'inline-flex',
  },
  flexItemPaddLeft: {
    paddingLeft: '7px',
  },
  counters: {
    height: '27px',
    display: 'flex',
    alignItems: 'center',
  },
  pagingNav: {
    height: '27px',
    paddingLeft: '5px',
  },
  label: {
    padding: '2px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    fontSize: '14px',
    lineHeight: '19px',
  },
  startLabel: {
    textAlign: 'right',
  },
  endLabel: {
    textAlign: 'left',
  },
  arrowWrapper: {
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    height: '27px',
    width: '27px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& path': {
      fill: '#6373A4',
    },
    '&:hover': {
      backgroundColor: 'silver',
      borderRadius: '8px',
      '& path': {
        fill: '#051D39',
      },
    },
  },
  arrowCommon: {
    height: '12px',
    width: '18px',
  },
  arrowPrevious: {
    transform: 'scaleX(-1) rotate(360deg)',
  },
  arrowPreviousPadding: {
    paddingRight: '14px',
  },
  pageContainer: {
    display: 'flex',
    paddingTop: '7px',
    width: '100%',
  },
  pageContainerLeft: {
    justifyContent: 'flex-start',
  },
  pageContainerCenter: {
    justifyContent: 'center',
  },
  pageContainerRight: {
    justifyContent: 'flex-end',
  },
  pagingContainerRightPadding: {
    paddingRight: '32px',
  },
  pagingContainerLeftPadding: {
    paddingLeft: '32px',
  },
});

export default styleSheet;
